import {
  GET_SPECIALTY_BY_BOOKING_REPORT_REQUEST,
  GET_SPECIALTY_BY_BOOKING_REPORT_SUCCESS,
  GET_SPECIALTY_BY_BOOKING_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";


export const getspecialtyByBookingReport = (token, formState, values, dateTypeId) => (dispatch) => {
  console.log("values", values)
  console.log("dateTypeId", dateTypeId)
  dispatch({ type: GET_SPECIALTY_BY_BOOKING_REPORT_REQUEST });
  const newData = {
    cy_start_date: formState.currentYearStartDate ? formState.currentYearStartDate : formState.cy_start_date,
    cy_end_date: formState.currentYearEndDate ? formState.currentYearEndDate : formState.cy_end_date,
    ly_start_date: formState.lastYearStartDate ? formState.lastYearStartDate : formState.ly_start_date,
    ly_end_date: formState.lastYearEndDate ? formState.lastYearEndDate : formState.ly_end_date,
    // region_id: (!values.regionID || values.regionID === "All") ? null : values.regionID,
    region_id: (!values.regionID || values.regionID === "All") ? null : values.regionID.toString(),
    gender_id: (!values.genderID || values.genderID === "All") ? null : values.genderID,
    sales_person_id: (!values.salePersonName || values.salePersonName === "All") ? null : values.salePersonName,
    condition: dateTypeId
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SpecialityByBookingReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SPECIALTY_BY_BOOKING_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SPECIALTY_BY_BOOKING_REPORT_ERROR,
        payload: [],
      });
    });
};

